module.exports = __webpack_public_path__ + "static/img/logo-bsre.0099932.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-bsre.png
// module id = 9gRb
// module chunks = 3